import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import ContactForm from '../components/contact/contactForm'
import background from '../_contentnew/pulsebanner2.webp'
import Header from '../components/header'

const ContactPage = () => {
  return (
    <>
      <Header background={background} text="Contact Us" />

      {/* TOP STRIP */}
      <Box
        sx={{
          backgroundColor: '#0A9B48',
          py: 3,
          px: 2,
        }}
      >
        <Typography
          sx={{
            color: 'white',
            textAlign: 'center',
            fontSize: {
              xs: '1.1rem',
              md: '1.4rem',
            },
            fontWeight: 600,
          }}
        >
          Get in touch with Pulse Pallets for pallet enquiries, pricing and delivery information.
        </Typography>
      </Box>

      {/* CONTACT DETAILS */}
      <Box sx={{ textAlign: 'center', py: 6, px: 2 }}>
        <Typography
          variant="h4"
          sx={{
            color: 'white',
            fontWeight: 700,
            mb: 4,
          }}
        >
          Contact Details
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md="auto">
            <Box
              component="a"
              href="tel:+441234567890"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                px: 3,
                py: 2,
                borderRadius: '12px',
                border: '1px solid rgba(87,200,77,0.2)',
                backgroundColor: '#2B2930',
                textDecoration: 'none',
                transition: 'all 0.25s ease',

                '&:hover': {
                  borderColor: '#57C84D',
                  transform: 'translateY(-3px)',
                },
              }}
            >
              <PhoneIcon sx={{ color: '#57C84D', fontSize: 26 }} />

              <Typography
                sx={{
                  color: 'white',
                  fontWeight: 500,
                }}
              >
                07862 079920
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md="auto">
            <Box
              component="a"
              href="mailto:info@pulsepallets.co.uk"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                px: 3,
                py: 2,
                borderRadius: '12px',
                border: '1px solid rgba(87,200,77,0.2)',
                backgroundColor: '#2B2930',
                textDecoration: 'none',
                transition: 'all 0.25s ease',

                '&:hover': {
                  borderColor: '#57C84D',
                  transform: 'translateY(-3px)',
                },
              }}
            >
              <EmailIcon sx={{ color: '#57C84D', fontSize: 26 }} />

              <Typography
                sx={{
                  color: 'white',
                  fontWeight: 500,
                }}
              >
                info@pulsepallets.co.uk
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <ContactForm />
    </>
  )
}

export default ContactPage